export const RESEND_EMAIL_CONFIRMATION_API_URL = '/user/default/resend-email-confirmation';

export const CONFIRMATION_EMAIL_SENT = 'CONFIRMATION_EMAIL_SENT';

export const COOKIE_PREFIX = '_emailConfig_';
export const COOKIE_HIDE_VALUE = '_true';

export const DEFAULT_DURATION = 60 * 60 * 24;
export const TIMEOUT_TO_FADE_AFTER_SEND = 2000;
